import { encode, LatLng } from '@googlemaps/polyline-codec';

import { STATIC_MAP_KEY } from '../constants';

const key = `key=${STATIC_MAP_KEY}`;
const BASE_URL = `https://maps.googleapis.com/maps/api/staticmap?${key}`;

interface SizeParams {
  height: number;
  width: number;
  scale: 1 | 2;
}

const setSize = ({ height, width, scale }: SizeParams): string => {
  if (scale === 1) {
    return `&size=${width}x${height}&scale=1`;
  }
  const scaledWidth = Math.round(width / 2);
  const scaledHeight = Math.round(height / 2);
  return `&size=${scaledWidth}x${scaledHeight}&scale=2`;
};

const setFormat = (format = 'jpg'): string => {
  return `&format=${format}`;
};

interface PolygonPayload {
  coords: google.maps.LatLng[];
  color: string;
  fillColor: string;
  strokeWidth: number;
}

const addPolygon = ({
  coords,
  color,
  fillColor,
  strokeWidth,
}: PolygonPayload) => {
  const LatLngArray = coords.map((latlng, index) => [
    latlng.lat(),
    latlng.lng(),
  ]);
  const encodedCoords = encodeCoords(LatLngArray);
  const polygon = `&path=color:${color}|weight:${strokeWidth}|fillcolor:${fillColor}|enc:${encodedCoords}`;
  return polygon;
};

const encodeCoords = (coords: number[][]): string => {
  return encode(coords, 5);
};

interface MapStaticFactoryParams {
  polygon: google.maps.Polygon | google.maps.Circle;
  color?: string;
  fillColor?: string;
  strokeWidth?: number;
  height: number;
  width: number;
  scale?: 1 | 2;
  format?: string;
}

export const mapStaticFactory = ({
  polygon,
  color = 'grey',
  fillColor = 'blue',
  strokeWidth = 1,
  height,
  width,
  scale = 1,
  format = 'jpg',
}: MapStaticFactoryParams): string => {
  const processedSize = setSize({ height, width, scale });
  const processedImg = setFormat(format);
  let polygonCoords;
  if (polygon instanceof google.maps.Circle) {
    const center = polygon.getCenter() as google.maps.LatLng;
    let polylinePoints = [];
    for (let i = 0; i < 360; i += 10) {
      const point = google.maps.geometry.spherical.computeOffset(
        center,
        polygon.getRadius(),
        i
      );
      polylinePoints.push(point);
    }
    polygonCoords = polylinePoints;
  } else {
    polygonCoords = polygon.getPath().getArray();
  }
  const processedCoords = addPolygon({
    coords: polygonCoords,
    color,
    fillColor,
    strokeWidth,
  });
  const URL = `${BASE_URL}${processedCoords}${processedImg}${processedSize}`;
  return URL;
};
